export enum AdmCodesDetails {
    Quarter1 = 276,
    Quarter2 = 277,
    Quarter3 = 278,
    Quarter4 = 279,

    Title_Page = 185,
    Addresses = 186,
    Executive_Summary = 187,
    Observation_Summary = 188,
    Persisting_Issues_Summary = 189,
    Detailed_Observations = 200,

    REPORT_UPDATE_MODE_Modified_During_Draft_Report = 181,
    REPORT_UPDATE_MODE_Modified_During_Final_Report = 182,
    REPORT_UPDATE_MODE_Modified_During_Draft_Report_Approval = 183,
    REPORT_UPDATE_MODE_Modified_During_Final_Report_Approval = 184,

    AUDIT_PROGRAM_WORKFLOW = 176,
    NC_AUDITOR_WORKFLOW = 177,
    DRAFT_REPORT_WORKFLOW = 178,
    FINAL_REPORT_WORKFLOW = 179,
    NC_AUDITEE_WORKFLOW = 180,
    PERSISTING_ISSUES_WORKFLOW = 201,
    AUDIT_TEMPLATE_WORKFLOW = 270,

    PDCA_STATUS_IMPROVEMENT_DONE_100 = 23,

    CD_INCLUDE_IN_EXECUTIVE_SUMMARY_YES = 360,
    CD_INCLUDE_IN_EXECUTIVE_SUMMARY_NO = 361,
    CD_INCLUDE_IN_EXECUTIVE_SUMMARY_OPTIONAL = 362


}